/* ============
 * State of the service
 * ============
 *
 * The initial state of the service.
 */

const {
  msFullscreenEnabled,
  mozFullScreenEnabled = msFullscreenEnabled,
  webkitFullscreenEnabled = mozFullScreenEnabled,
  fullscreenEnabled = webkitFullscreenEnabled,
} = document;

export default {
  optOut: null,
  mobilePortrait: false,
  fullscreenEnabled: !!fullscreenEnabled, /* IE11 */
  topmenu: true,
  theme: {},
  routeParams: undefined,
  exteriorNavBarVisible: false,
  isMiniMapVisible: true,
};
